import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import { TaxationTypeNamePipe } from '@zaoblako/web/shared/pipes/taxation-type-name.pipe';
import { TaxationTypeDescriptionPipe } from '@zaoblako/web/shared/pipes/taxation-type-description.pipe';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-taxation-single-select',
  templateUrl: './taxation-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent, TaxationTypeNamePipe, TaxationTypeDescriptionPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxationSingleSelectComponent {
  public taxations: TaxationTypeEnum[] = Object.values(TaxationTypeEnum);

  @Input() public selectedTaxation: TaxationTypeEnum;
  @Output() public selectedTaxationChange = new EventEmitter<TaxationTypeEnum>();

  @Input() public labelInput = false;

  @Input() public class = '';
  @Input() public styleClass = '';

  @Input() public disabled = false;

  public toTaxation(taxation: any): TaxationTypeEnum {
    return taxation as TaxationTypeEnum;
  }
}
